import { Grid } from "@material-ui/core";
import { Text } from "sunrise-ui";
import { displayDate } from "../../utilities/displayDateUtils";

const ReportsFeedTable = (props: any) => {

    const { listData, title } = props;


    const getFeedSentence = (type: string, machine: string, value: string) => {

        let message = '';
        let feedData = '';

        switch (type.toUpperCase()) {
            case 'INSURANCE':
            case 'TPI':
            case 'RC': message = `Machine Number ${machine} ${type} is expiring soon so please renew it before `;
                feedData = displayDate(value);
                break;
            case 'HMR': message = `Machine Number ${machine} service is due on `;
                feedData = `HMR ${value}`;
                break;
        }

        return (
            <span className="expense_recent-bill-text">{message} <span style={{ color: 'red' }}>{feedData}</span></span>
        )
    }

    return (
        <Grid container xs={12} className="d-flex bg--white box--shadow p1 mt1">
            <Grid item xs={12}>
                <Text
                    type="normal"
                    fonts="normal"
                    fontSize={18}
                    className="mb0 mt0"
                >
                    <span className="fw500">{title}</span>
                </Text>
            </Grid>

            {listData && listData?.map((item: any, index: number) => (
                <Grid key={`Report_feed_${index}`} xs={12} className="d-flex v-center mb1 mt1">
                    <Grid className="icon_container client_icon mr" style={{ color: '#A15000' }}>
                        {(index + 1)}
                    </Grid>
                    <Text
                        type="normal"
                        fonts="normal"
                        fontSize={16}
                        className="mb0 mt0 fw400"
                    >
                        {getFeedSentence(item?.feedType, item?.machineDetails, item?.value)}
                    </Text>
                </Grid>
            ))}

        </Grid>
    );
}

export default ReportsFeedTable;